import { COMMITMENT_TYPES } from './types';
import { FIELDS } from 'modules/cm/fields/types';
import { CreditCommitmentTypeBuilder } from './CreditCommitmentTypeBuilder';
import { CreditCommitmentLabelBuilder } from './CreditCommitmentLabelBuilder';
import { LiabilityInitialData, LiabilityFormData, DataDirector, LiabilityRequestData } from './types';
import {
  CommonType,
  CreditCard,
  MaintenancePayments,
  Other,
  StudentsLoan,
  UnsecuredLoan,
  BuyToLetMortgage,
  PensionContribution,
} from './creditCommitmentDirectors';

export const liabilityTypeDirectorFactory = (type: string, liabilityId: number): DataDirector => {
  const builder = new CreditCommitmentTypeBuilder(liabilityId);
  const creditCommitmentDirectorsMap = new Map<string, DataDirector>([
    [COMMITMENT_TYPES.CREDIT_CARD.toString(), new CreditCard(builder, new CreditCommitmentLabelBuilder())],
    [COMMITMENT_TYPES.UNSECURED_LOAN.toString(), new UnsecuredLoan(builder, new CreditCommitmentLabelBuilder())],
    [COMMITMENT_TYPES.STUDENT_LOAN.toString(), new StudentsLoan(builder, new CreditCommitmentLabelBuilder())],
    [COMMITMENT_TYPES.OTHER.toString(), new Other(builder, new CreditCommitmentLabelBuilder())],
    [
      COMMITMENT_TYPES.PENSION_CONTRIBUTION.toString(),
      new PensionContribution(builder, new CreditCommitmentLabelBuilder()),
    ],
    [
      COMMITMENT_TYPES.MAINTENANCE_PAYMENTS.toString(),
      new MaintenancePayments(builder, new CreditCommitmentLabelBuilder()),
    ],
    [
      COMMITMENT_TYPES.BUY_TO_LET_MORTGAGE.toString(),
      new BuyToLetMortgage(builder, new CreditCommitmentLabelBuilder()),
    ],
  ]);

  return creditCommitmentDirectorsMap.get(type) || new CommonType(builder, new CreditCommitmentLabelBuilder());
};

export const createLiability = (id: number): LiabilityFormData => ({
  [FIELDS.EXPENDITURE_ID]: id,
  [FIELDS.EXPENDITURE_TYPE]: null,
  [FIELDS.EXPENDITURE_TYPE]: null,
  [FIELDS.EXPENDITURE_CREDIT_LIMIT]: null,
  [FIELDS.EXPENDITURE_BALANCE]: null,
  [FIELDS.EXPENDITURE_DESCRIPTION]: null,
  [FIELDS.EXPENDITURE_AMOUNT]: null,
  [FIELDS.EXPENDITURE_FREQUENCY]: null,
  [FIELDS.EXPENDITURE_END_DATE]: null,
  [FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES]: null,
  [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN]: null,
  [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN]: null,
});

export const mapLiabilityResponseItem = (data: LiabilityInitialData): LiabilityFormData => {
  return {
    [FIELDS.EXPENDITURE_ID]: data.id,
    [FIELDS.EXPENDITURE_TYPE]: data.type,
    [FIELDS.EXPENDITURE_CREDIT_LIMIT]: data.creditLimit,
    [FIELDS.EXPENDITURE_BALANCE]: data.balance,
    [FIELDS.EXPENDITURE_DESCRIPTION]: data.description,
    [FIELDS.EXPENDITURE_AMOUNT]: data.amount,
    [FIELDS.EXPENDITURE_FREQUENCY]: data.frequency,
    [FIELDS.EXPENDITURE_END_DATE]: data.endDate,
    [FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES]: data.totalNumberOfProperties,
    [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN]: data.willBeClearedBeforeLoan,
    [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN]: data.willBeClearedByLoan,
  };
};

export const mapLiabilityFormData = (data: LiabilityFormData): LiabilityRequestData => {
  return {
    id: data[FIELDS.EXPENDITURE_ID],
    type: data[FIELDS.EXPENDITURE_TYPE],
    creditLimit: data[FIELDS.EXPENDITURE_CREDIT_LIMIT],
    balance: data[FIELDS.EXPENDITURE_BALANCE],
    description: data[FIELDS.EXPENDITURE_DESCRIPTION],
    amount: data[FIELDS.EXPENDITURE_AMOUNT],
    frequency: data[FIELDS.EXPENDITURE_FREQUENCY],
    endDate: data[FIELDS.EXPENDITURE_END_DATE],
    totalNumberOfProperties: data[FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES],
    willBeClearedBeforeLoan: data[FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN],
    willBeClearedByLoan: data[FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN],
  };
};
